<template>
    <div>
      <van-dropdown-menu class="vandrop">
        <van-dropdown-item v-model="value" :options="option" />
        <van-dropdown-item v-model="value1" :options="list" />
      </van-dropdown-menu>
    </div> 
</template>

<script>
import Vue from 'vue';
import { DropdownMenu, DropdownItem } from 'vant';

Vue.use(DropdownMenu);
Vue.use(DropdownItem);

import classlist from '@/components/ClassList'
import VueEvent from '../model/VueEvent';
import URL from '../api/index'
export default {
    components:{

    },
    data() {
        return {
        value: 0,
        value1: 0,
        subgect:1,
        d:1,
        kemu:0,
        switch1: false,
        switch2: false,
        option: [],
        list: [],
        }
    },
    watch:{
        value(val){
            this.getsubject(val)
            // this.subgect=val
             VueEvent.$emit('nianji',val)
        },
        value1(val){
            VueEvent.$emit('kemu',val)
        }
    },
    mounted(){
        this.getgrade()
        this.getsubject(this.subgect)
    },
    methods:{
        onConfirm() {
        this.$refs.item.toggle();
    },
    convertKey (arr, key) {
        let newArr = [];
        arr.forEach((item, index) => {
            let newObj = {};
            for (var i = 0; i < key.length; i++) {
            newObj[key[i]] = item[Object.keys(item)[i]]
            }
            newArr.push(newObj);
        })
        return newArr;
    },
    getgrade(){
        var that=this
            this.$axios({
            method:'post',    
            url:URL.get_grade_list
        }).then((res)=>{
            // console.log(res)
            that.option = []
            that.option = that.option.concat({grade_id:0,gid: 0, grade_name: '年级'}).concat(res.data.result)
            that.option=that.convertKey(that.option, ['a','value', 'text'])     
            console.log(that.option);
        })
    },
    getsubject(d){
        var that=this
            this.$axios({
            method:'post',    
            url:URL.get_subject_list,
            data:{
                gid:d
            }
        }).then((res)=>{
            // console.log(res)
            that.list = []
            that.list = that.list.concat({gid:d, sid: 0, subject_name: '科目'}).concat(res.data.result)
            that.list = that.convertKey(that.list, ['a','value', 'text'])
            // console.log(that.list);
        })
    },
  }
}
</script>
<style>
/* .van-tab__pane{
    margin-left: -18px
} */

</style>
<style scoped>
.vandrop{
  width: 100%;
  line-height: 45px;
  text-align: center;
  font-size: 14px;
  position: fixed;
  top: 50;
  left: 0;
  z-index: 2;
  background-color: #fff;
}
.van-dropdown-menu  /deep/ .van-dropdown-menu__title{
    position: relative;
    /* box-sizing: border-box; */
    max-width: 80%;
    padding: 0 8px;
    color: #323233;
    font-size: 15px;
    line-height: 18px;
    cursor: pointer;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/seating.vue